import tw from "tailwind-styled-components";
const SDropdownButton = tw.div`
  flex
  justify-center
  
  rounded-md
  text-white
  text-xs
  ${({ $full })=>$full ? `
        w-full
    ` : `
        w-auto
    `}

  ${({ $small })=>$small ? `
        p-1
        px-2
    ` : `
        p-2
        px-3
        !h-[26px] !border !border-white !border-opacity-10
        text-opacity-100
    `}

  ${({ $disabled })=>$disabled ? `
       bg-grayscale-light
        cursor-not-allowed
        text-opacity-50
      ` : `
        bg-grayscale-light
        cursor-pointer
    `}
`;
export default SDropdownButton;
